import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    buttonText: '',
    contacts: [],
    // Template content (people, place, hours, departments, form, brand, floating).
    // Stored as one JSON payload in Core, so a new template needs no new field here.
    data: {},
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'card',
  },
  buttonDesign: {},
  itemDesign: {},
  containerDesign: {},
};

export const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    contactsStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const blockContent = block.blockContent ?? {};
      const blockDesign = block.blockDesign ?? {};
      const { buttonDesign, itemDesign, containerDesign } = blockDesign;
      const heading = blockContent.heading ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = {
        ...buttonDesign,
        backgroundColor: buttonDesign?.backgroundColor ?? '#000000',
        textColor: buttonDesign?.textColor ?? '#ffffff',
      };
      state.itemDesign = {
        shape: itemDesign?.shape ?? 'round',
        border: itemDesign?.border ?? 'none',
        borderColor: itemDesign?.borderColor ?? '#ECECF0',
        shadow: itemDesign?.shadow ?? 'none',
        shadowColor: itemDesign?.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        buttonText: blockContent.buttonText ?? '',
        contacts: blockContent.contacts ?? [],
        data: blockContent.data ?? {},
        heading: {
          ...heading,
          title: heading.title ?? '',
          description: heading.description ?? '',
          textAlign: heading.textAlign ?? 'left',
          image: heading.image ?? '',
          divider: heading.divider ?? '',
          position: heading.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    contactsClear: () => initialState,

    contactsUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    contactsUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    contactsUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    contactsUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    contactsSetItems: (state, action) => {
      state.blockContent.contacts = action.payload ?? [];
    },
    contactsUpdateData: (state, action) => {
      state.blockContent.data = action.payload ?? {};
    },
  },
});

export const {
  contactsStore,
  contactsClear,
  contactsUpdateIsLoading,
  contactsUpdateIsActive,
  contactsUpdateBlockContent,
  contactsUpdateBlockDesign,
  contactsSetItems,
  contactsUpdateData,
} = contactsSlice.actions;

export const selectContactsIsLoading = (state) => state.contacts.isLoading;

export const selectContactsId = (state) => state.contacts.id;
export const selectContactsUID = (state) => state.contacts.uid;
export const selectContactsSID = (state) => state.contacts.sid;

export const selectContactsBlockContent = (state) => state.contacts.blockContent;
export const selectContactsData = (state) => state.contacts.blockContent.data;

export const selectContactsSortItems = createSelector([selectContactsBlockContent], ({ contacts }) => {
  return sortItems(contacts);
});

export const selectContactsBlockDesign = (state) => state.contacts.blockDesign;
export const selectContactsItemDesign = (state) => state.contacts.itemDesign;
export const selectContactsButtonDesign = (state) => state.contacts.buttonDesign;
export const selectContactsContainerDesign = (state) => state.contacts.containerDesign;

export default contactsSlice.reducer;
